/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Payment_Failed_TooltipInputs */



/**
* | output |
* | --- |
* | "Update payment method to add members" |
*
* @param {Members_Add_Payment_Failed_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_payment_failed_tooltip = /** @type {((inputs?: Members_Add_Payment_Failed_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Payment_Failed_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlungsmethode aktualisieren, um Mitglieder hinzuzufügen")
	return /** @type {LocalizedString} */ ("Update payment method to add members")
});